// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingsStatusCell-moduleRentalPortalListingsStatusCell__QLO9B TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "RentalPortalListingsStatusCell" }
